import Quiz from './Quiz.vue'
export default Quiz
